// extracted by mini-css-extract-plugin
export default {"Team":"TeamContainer-module_Team__wxFbI"};